import {
  REQUEST_CASE_STAGE_IMAGES,
  RECEIVE_CASE_STAGE_IMAGES_SUCCESS,
  RECEIVE_CASE_STAGE_IMAGES_FAILURE,
  RESET_CURRENT_STAGE_IMAGES,
} from '../actions/actionTypes';

import initialState from './initialState';

export default function caseStageImageReducer(state = initialState.currentCaseStageImages, action) {
  switch (action.type) {
    case REQUEST_CASE_STAGE_IMAGES:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case RECEIVE_CASE_STAGE_IMAGES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        images: [...state.images, ...action.images],
        lastUpdated: action.receivedAt,
      };
    case RECEIVE_CASE_STAGE_IMAGES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case RESET_CURRENT_STAGE_IMAGES:
      return {
        ...state,
        isFetching: false,
        images: [],
        lastUpdated: Date.now(),
        error: null,
      };
    default:
      return state;
  }
}
